import { get, post } from '../client';

export const emailApi = {
  status: () => get('/email/status'),
  sendTest: (body) => post('/email/test', body),
};
